import React from 'react'
import TextareaAutosize from "react-textarea-autosize";
import { useTranslation } from "react-i18next";
import { fieldAutosizeStyle, resolveFieldDisplaySize } from "../../app/helpers/formFieldDisplayHelper";

const NewInputGeneric = ({ handleChange, values, errors, placeholderVal, field, max_length, moduleText, occupation = 6, css_class}) => {
  const { t } = useTranslation();
  const displaySize = resolveFieldDisplaySize(max_length);
  const useAutosize = displaySize.asTextarea;

  return (
    <div className={`col-md-${occupation} ${css_class || ""}`}>
      <label htmlFor={field} className="form-label tit-view">
      {t(`${moduleText}.short.${field}`)}
      </label>
      <div className="control">
        {useAutosize ? (
          <TextareaAutosize
            cacheMeasurements
            minRows={displaySize.minRows}
            maxRows={displaySize.maxRows}
            style={fieldAutosizeStyle}
            className={`form-control txt-view ${errors[field] && "border border-danger"}`}
            name={field}
            id={field}
            onChange={(event) => handleChange(event, field)}
            value={values[field] || ""}
            required
            maxLength={max_length}
            placeholder={placeholderVal ? t(`${moduleText}.short.${field}`) : null}
          />
        ) : (
          <input
            autoComplete="off"
            className={`form-control txt-view ${errors[field] && "border border-danger"}`}
            style={{ minHeight: "2.6rem" }}
            type="text"
            name={field}
            id={field}
            onChange={(event) => handleChange(event, field)}
            value={values[field] || ""}
            required
            maxLength={max_length}
            placeholder={placeholderVal ? t(`${moduleText}.short.${field}`) : null}
          />
        )}
        {values[field] && (
          <span className="charLeft">
            {values[field].length}/{max_length} {t("label.characters")}
          </span>
        )}
        {errors[field] && <pre> <p className="help text-danger">{errors[field]}</p> </pre>}
      </div>
    </div>
  )
}

export default NewInputGeneric
